import type { Components } from "react-markdown";

export const markdownComponents: Components = {
  h1: ({ children }) => <h1 className="memo-h1">{children}</h1>,
  h2: ({ children }) => <h2 className="memo-h2">{children}</h2>,
  h3: ({ children }) => <h3 className="memo-h3">{children}</h3>,
  p: ({ children }) => <p className="memo-p">{children}</p>,
  ul: ({ children }) => <ul className="memo-list">{children}</ul>,
  ol: ({ children }) => <ol className="memo-list memo-list-numbered">{children}</ol>,
  li: ({ children }) => <li className="memo-li">{children}</li>,
  table: ({ children }) => <div className="memo-table-wrap"><table className="memo-table">{children}</table></div>,
  th: ({ children }) => <th className="memo-th">{children}</th>,
  td: ({ children }) => <td className="memo-td">{children}</td>,
  strong: ({ children }) => <strong className="memo-strong">{children}</strong>
};
